import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AlertCircle, ArrowRight } from "lucide-react";

export default function InsufficientBalanceModal({ open, onOpenChange, currentBalance = 0, requiredAmount = 0, intent = null }) {
    const navigate = useNavigate();
    const deficit = Math.max(0, Math.round(requiredAmount - currentBalance));

    const goRecargar = () => {
        if (intent) {
            try {
                localStorage.setItem("p2w-bet-intent", JSON.stringify({ ...intent, ts: Date.now() }));
            } catch { /* noop */ }
        }
        onOpenChange(false);
        const params = new URLSearchParams();
        params.set("monto", String(deficit));
        if (intent?.market_id) params.set("intent", intent.market_id);
        navigate(`/wallet/recargar?${params.toString()}`);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="insufficient-modal" className="bg-p2w-surface border-p2w-line text-white max-w-md">
                <DialogHeader>
                    <DialogTitle className="font-sora font-extrabold text-2xl flex items-center gap-2">
                        <AlertCircle className="w-5 h-5 text-p2w-amber" /> Saldo insuficiente
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-4 mt-2">
                    <p className="text-sm text-p2w-gray">No tienes saldo suficiente para esta apuesta. Recarga lo que te falta y te traemos de vuelta al mercado.</p>
                    <div className="rounded-xl border border-p2w-line bg-p2w-elevated p-4 space-y-2">
                        <Row label="Tu saldo" value={currentBalance} />
                        <Row label="Apuesta" value={requiredAmount} />
                        <div className="border-t border-p2w-line pt-2">
                            <Row label="Te faltan" value={deficit} color="text-p2w-amber" bold testid="deficit-row" />
                        </div>
                    </div>
                </div>
                <DialogFooter className="mt-4 gap-2">
                    <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="insufficient-cancel" className="border-p2w-line bg-transparent text-white hover:bg-p2w-elevated hover:text-white">
                        Cancelar
                    </Button>
                    <Button onClick={goRecargar} data-testid="insufficient-recargar" className="bg-p2w-green text-p2w-green-fg hover:bg-p2w-green/90 font-semibold gap-2">
                        Recargar y continuar <ArrowRight className="w-4 h-4" />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

function Row({ label, value, color, bold, testid }) {
    return (
        <div className="flex items-center justify-between" data-testid={testid}>
            <span className="text-sm text-p2w-gray">{label}</span>
            <span className={`text-sm number-tabular ${bold ? "font-sora font-bold" : ""} ${color || "text-white"}`}>
                {Number(value || 0).toLocaleString("es-CO")}
            </span>
        </div>
    );
}
